import { ACTIVE_ENV, EnvConfig } from "./EnvConfig";

const DEFAULT_FUNCTIONS_REGION = "asia-southeast1";
const DEFAULT_LOCAL_FUNCTIONS_ORIGIN = "http://127.0.0.1:5001";
const DEFAULT_LOCAL_FUNCTIONS_REGION = "0";

const getFunctionRegion = (config = EnvConfig) => {
  if (ACTIVE_ENV === "local" || config.useEmulators) {
    return config.functionsEmulatorRegion || DEFAULT_LOCAL_FUNCTIONS_REGION;
  }

  if (config.databaseURL && config.databaseURL.split(".").length === 4) {
    return config.databaseURL.split(".")[1];
  }

  return config.functionsRegion || DEFAULT_FUNCTIONS_REGION;
};

export const getFunctionBaseUrl = (config = EnvConfig) => {
  const projectId = config.projectId || EnvConfig.projectId;
  const region = getFunctionRegion(config);

  if (ACTIVE_ENV === "local" || config.useEmulators) {
    const origin = config.functionsEmulatorOrigin || DEFAULT_LOCAL_FUNCTIONS_ORIGIN;
    return `${origin}/${projectId}/${region}`;
  }

  return `https://${region}-${projectId}.cloudfunctions.net`;
};

export const getFunctionUrl = (functionName, config = EnvConfig) => {
  return `${getFunctionBaseUrl(config)}/${functionName}`;
};
